let csrfToken = null;
const csrfTokenInput = document.querySelector(
  "input[name=csrfmiddlewaretoken]",
);
if (csrfTokenInput) {
  csrfToken = csrfTokenInput.value;
}
import { ErrorSwal, getTranslation } from "../app";

export const toggleBetweenElements = (
  element1,
  element2,
  speed = 500,
  callbackFn,
) => {
  $(element1).fadeOut(speed / 2, () => {
    $(element2).fadeIn(speed / 2, callbackFn);
  });
};

export const ajaxPost = (url, data, form = null) => {
  // before post actions
  if (form) {
    $(form).find(".alertWrapper").remove();
    $(form).find(".is-invalid").removeClass("is-invalid");
    $(form).find(".invalid-feedback").remove();
    $(form).find("button[type=submit]").attr("disabled", "disabled");
  }

  const lang = document.querySelector("html").getAttribute("lang");

  // add csrf token to data
  if (typeof data === "undefined") {
    // sourcery skip: dont-reassign-parameters
    data = [
      { name: "csrfmiddlewaretoken", value: csrfToken },
      { name: "lang", value: lang },
    ];
  } else if (Array.isArray(data)) {
    data.push({ name: "csrfmiddlewaretoken", value: csrfToken });
    data.push({ name: "lang", value: lang });
  } else if (typeof data === "object") {
    data["csrfmiddlewaretoken"] = csrfToken;
    data["lang"] = lang;
  }

  return new Promise((resolve, reject) => {
    $.post(url, data, (response) => {
      resolve(response);
    })
      .fail((response) => {
        if (response.status >= 500) {
          if (response.responseJSON) {
            let responseJson = response.responseJSON;
            let errorText = "";
            if (response.responseJSON["request_id"]) {
              errorText = `${getTranslation("request_id")}: ${
                response.responseJSON["request_id"]
              }`;
              responseJson["request_id"] = errorText;
            } else {
              const errorList = parceAjaxErrorResponse(responseJson);
              if (errorList.length > 0) {
                errorText = errorList.join("<br>");
              }
            }
            ErrorSwal.fire({ html: errorText }).then(() => {});
            reject(responseJson);
          }

          ErrorSwal.fire({}).then(() => {
            console.log("Server error", response);
          });

          if (response.status === 502) {
            reject(getTranslation("error_please_try_again_later"));
          }

          reject(
            getTranslation("server_error") +
              ". " +
              getTranslation("error_please_try_again_later"),
          );
        }
        if (response.status === 404) {
          ErrorSwal.fire({}).then(() => {
            console.log("Page not found error", response);
          });
          reject(
            getTranslation("operation_failed") +
              ". " +
              getTranslation("page_not_found"),
          );
        }
        if (response.status === 403) {
          ErrorSwal.fire({
            icon: "error",
            titleText: "Xəta!",
            text: getTranslation("no_permission_to_perform_this_action"),
          }).then(() => {
            console.log("Permission denied error", response);
          });
          reject(getTranslation("no_permission_to_perform_this_action"));
        }
        // custom http status code for csrf token error
        if (response.status === 463) {
          ErrorSwal.fire({
            icon: "warning",
            position: "center",
            text: "CSRF Token yoxlamanı keçmədi. Xahiş olunur səhifəni yeniləyəsiniz. Bu kömək olmasa brovserinizdə cookie-lərin yazılmasına icazə verin.",
          }).then(() => {
            console.log("CSRF validation error", response);
          });
        }
        // custom http status code for http redirect
        if (response.status === 464) {
          console.log("Redirecting to", response.responseJSON["redirect_url"]);
          window.location.href = response.responseJSON["redirect_url"];
          reject(getTranslation("redirecting") + "...");
        }
        reject(response.responseJSON);
      })
      .always(() => {
        // after post actions
        if (form) {
          $(form).find("button[type=submit]").removeAttr("disabled");
          $(form).find(".tta-loading").remove();
        }
      });
  });
};

export const parceAjaxErrorResponse = (errors) => {
  let errorList = [];
  const getErrorText = (errors) => {
    if (typeof errors === "object") {
      for (const key of Object.keys(errors)) {
        getErrorText(errors[key]);
      }
    } else {
      errorList.push(errors);
    }
    return errorList;
  };

  if (!errors) {
    errorList.push(
      getTranslation("server_error") +
        ". " +
        getTranslation("error_please_try_again_later"),
    );
  } else {
    getErrorText(errors);
  }

  return errorList;
};

export const bsAlert = (options) => {
  const optionsDefault = {
    parent: "body",
    message: "",
    type: "danger",
    scroll: true,
    shake: true,
    place: "prepend",
  };

  // sourcery skip: dont-reassign-parameters
  options = { ...optionsDefault, ...options };

  let shakeClass = "" ? options.shake : "shake";

  options.message = parceAjaxErrorResponse(options.message).join("<br>");

  const alert = [
    `<div class="alertWrapper alert alert-${options.type} alert-dismissible pb-2 ${shakeClass}" role="alert">`,
    ` <div class="mb-2"><strong>${getTranslation("error")}!</strong></div>`,
    ` <div class="mb-2">${options.message}</div>`,
    ` <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>`,
    `</div>`,
  ].join("");

  if (options.place === "prepend") {
    $(options.parent).prepend(alert);
  } else {
    $(options.parent).append(alert);
  }

  if (scroll) {
    const scrollElement = $(options.parent).find(".alertWrapper")[0];
    $("html, body").animate({ scrollTop: scrollElement.offsetTop - 50 }, 100);
  }
};

export const ajaxErrorAlert = (errors, form) => {
  const generalErrors = [];
  let lastErrorElement = null;
  if (typeof errors === "string") {
    // sourcery skip: dont-reassign-parameters
    errors = [errors];
  }
  for (let error in errors) {
    const formElement = form.find(
      `input[name=${error}]:visible, select[name=${error}], textarea[name=${error}]`,
    );
    if (formElement.length > 0) {
      formElement.addClass("is-invalid");
      let parentDiv = formElement.parent("div");
      parentDiv.children(".invalid-feedback").remove();
      parentDiv.append(
        Array.isArray(errors[error])
          ? `<div class="invalid-feedback">${errors[error].join("<br>")}</div>`
          : `<div class="invalid-feedback">${errors[error]}</div>`,
      );
      lastErrorElement = formElement[0];
    } else {
      generalErrors.push(errors[error]);
    }
  }

  if (generalErrors.length > 0) {
    const alertWrapperParent = $(form).find("#alertWrapperParent");
    if (alertWrapperParent.length > 0) {
      bsAlert({ parent: alertWrapperParent, message: generalErrors });
    } else {
      bsAlert({ parent: form, message: generalErrors });
    }
  } else if (lastErrorElement) {
    lastErrorElement.focus();
  }
};
